//dependencias
import React, { Component } from 'react';

//componentes
import AutorizarBoletin from './autorizarBoletin'

class Index extends Component {

    render(){
        return(
            <div>
                <AutorizarBoletin />
            </div>
        );
    }

}
export default Index;